export default "__VITE_ASSET__CNb8rfAD__"